import ArticlePushMarketing from './articlePushMarkting'

const articlePushMarketing = new ArticlePushMarketing()
articlePushMarketing.init()
